// @ts-strict-ignore
import { getDirMode } from 'mobile_web/modules/platform'
import { getOriginalLanguageName } from 'mobile_web/modules/settings/functions'
import strings from 'mobile_web/strings'
import { LanguageCode } from 'mytours-read-api-typescript'
import { convertLanguages, Language } from 'mytours-read-common'
import React from 'react'
import { Button, Card, CardContent, CardHeader, CardTitle, Item, Label, List } from '@mytours/components'
import Modal from '../modal'
import './styles.less'
import { EventActionsEnum, sendEvent } from 'mobile_web/modules/logging/analytics'

interface Props {
	selectLanguage: (language: Language) => void
	supportedLanguages: LanguageCode[]
	selectedLanguage?: Language
	backdropDismiss?: boolean
	closeModal?: () => void
	showBackdrop?: boolean
	isOpen: boolean
	onDidDismiss?: () => void
}

const LanguageModal: React.FC<Props> = ({
	backdropDismiss = true,
	showBackdrop = true,
	supportedLanguages,
	selectedLanguage,
	selectLanguage,
	closeModal,
	isOpen,
	onDidDismiss,
}): JSX.Element => {
	const languages = convertLanguages(supportedLanguages).sort((a, b) => a.name.localeCompare(b.name))

	const ItemContent = ({ languageCode, languageName }) => (
		<>
			<Label as="span">{languageName}</Label>
			<p lang={languageCode}>{getOriginalLanguageName(languageCode)}</p>
		</>
	)

	return (
		<Modal
			data-cy="language-modal"
			isOpen={isOpen}
			showBackdrop={showBackdrop}
			backdropDismiss={backdropDismiss}
			cssClass="language-select-modal"
			onDidDismiss={onDidDismiss}
		>
			<Card variant="ios" dir={getDirMode()}>
				<CardHeader>
					<CardTitle as="h2" id="dialogTitle">
						{strings.select_language}
					</CardTitle>
					{closeModal && (
						<Button variant="clear" className="close" onClick={closeModal} aria-label={strings.cancel}>
							<i className="fal fa-xmark" />
						</Button>
					)}
				</CardHeader>
				<CardContent>
					<List variant="ios" aria-labelledby="dialogTitle">
						{selectedLanguage && (
							// Ionic turns this into a listitem, which does not allow aria-selected.
							<Item role="button" className="active" aria-current="true" arial-label={selectedLanguage.name || ''}>
								<i className="icon far fa-check" />
								<ItemContent languageCode={selectedLanguage.code} languageName={selectedLanguage.name} />
							</Item>
						)}
						{languages.map(
							(row, index) =>
								selectedLanguage?.code !== row.code && (
									<Item
										data-cy={`language-${row.code}`}
										arial-label={row.name || ''}
										role="button"
										key={index}
										onClick={() => {
											sendEvent(EventActionsEnum.ChangeLanguage, {
												language: row.code,
											})
											selectLanguage(row)
										}}
									>
										<ItemContent languageCode={row.code} languageName={row.name} />
									</Item>
								),
						)}
					</List>
				</CardContent>
			</Card>
		</Modal>
	)
}

export default LanguageModal
